import { render, staticRenderFns } from "./ToolsBar.vue?vue&type=template&id=f2afdd4e"
import script from "./ToolsBar.vue?vue&type=script&lang=js"
export * from "./ToolsBar.vue?vue&type=script&lang=js"
import style0 from "./ToolsBar.vue?vue&type=style&index=0&id=f2afdd4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports